import RestClientService from 'Services/RestClientService';

class FlightTicketApiService {
  static async getByPositionAssignId(positionAssignId) {
    return RestClientService.GetFromGpx(`F2W/flight-ticket?PositionAssignId=${positionAssignId}`);
  }

  static async getByStatusAndId(status, ticketId) {
    const normalizedStatus = status?.toLowerCase() || status;
    return RestClientService.Get(`flight-ticket/${normalizedStatus}/${ticketId}`);
  }

  static async insertManual(files, data) {
    return RestClientService.Upload('flight-ticket/insert-manual', files, data);
  }

  static async update(ticketId, data) {
    return RestClientService.Post(`flight-ticket/update/${ticketId}`, data);
  }

  static async submitStatusChange(ticketId, data) {
    return RestClientService.Post(`flight-ticket/submit-status-from-to/${ticketId}`, data);
  }

  static async delete(ticketId) {
    return RestClientService.Post(`flight-ticket/delete/${ticketId}`, {});
  }

  static async acquireLock(ticketId) {
    return RestClientService.Post(`flight-ticket/lock/${ticketId}`, {});
  }

  static async releaseLock(ticketId, email) {
    return RestClientService.Delete(`flight-ticket/release-lock/${ticketId}?email=${encodeURIComponent(email)}`, null);
  }

  static async getLockStatus(ticketId) {
    return RestClientService.Get(`flight-ticket/lock-status/${ticketId}`);
  }

  static async resetLockTimer(ticketId) {
    return RestClientService.Post(`flight-ticket/reset-lock-timer/${ticketId}`, {});
  }

  static async updateFlightInfo(flightId, data) {
    return RestClientService.Post(`flight-ticket/update/${flightId}`, data);
  }

  static async deleteFlightInfo(ticketId, flightNumber) {
    return RestClientService.Post(`flight-ticket/delete-flight/${ticketId}`, { flightNumber });
  }

  static async addComment(ticketId, text) {
    return RestClientService.Post('comment/insert', { text, ticketId });
  }

  static async deleteComment(flightTicketId, commentId) {
    return RestClientService.Delete(`comment/delete/${flightTicketId}/${commentId}`, null);
  }

  static async listAttachments(flightTicketId) {
    return RestClientService.Get(`attachment/list/${flightTicketId}`);
  }

  static async uploadAttachment(flightTicketId, file) {
    const formValues = [{ key: 'flightTicketId', value: flightTicketId }];
    return RestClientService.Upload('attachment/upload', file, formValues);
  }

  static async deleteAttachment(id, attachmentId, attachementName) {
    return RestClientService.Post('attachment/delete', { id, attachmentId, attachementName });
  }

  static async downloadAttachment(id, attachmentId, attachementName) {
    return RestClientService.Download('attachment/download', { id, attachmentId, attachementName }, attachementName);
  }

  static async downloadPdf(flightTicketId, fileName) {
    return RestClientService.Download(`pdf/${flightTicketId}`, {}, fileName);
  }

  static async setGreenLight(flightTicketId) {
    return RestClientService.Post(`flight-ticket/set-greenLight/${flightTicketId}`);
  }

  static async checkTppAssignment(mplid, staffId) {
    return RestClientService.Get(`flight-ticket/check-tpp-assigment/${mplid}/${staffId}`);
  }

  static async checkEcAssignment(ecPositionId, sliceId, staffId) {
    return RestClientService.Get(`flight-ticket/check-ec-assigment/${ecPositionId}/${sliceId}/${staffId}`);
  }
}

export default FlightTicketApiService;
